import { formatNumber } from '../../../../utils/format-number-util';

const columns = (props) => [
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_number' }),
      sortBy: 'customerNumber'
    },
    accessor: (order) => ({
      display: order.customerNumber
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_name' }),
      sortBy: 'customerName'
    },
    accessor: (order) => ({
      display: order.customerName.toLowerCase(),
      style: {
        textTransform: 'capitalize'
      }
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'route' }),
      sortBy: 'routeNumber'
    },
    accessor: (order) => ({
      display: order.routeNumber
    })
  },
  {
    header: {
      display: 'Created At'
    },
    accessor: (order) => ({
      display: new Date(order.mrsOrderId.split(':')[1] * 1).toLocaleString()
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'total' })
    },
    accessor: (order) => ({
      display: `$${formatNumber(
        order.lineItems.reduce(
          (total, item) => total + item.adjustedPrice.priceItem * item.quantity,
          0
        ),
        2
      )}`
    }),
    shared: {
      isNumeric: true
    }
  }
];

export default columns;
